import React, { useState, useEffect } from "react";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import ModernHeader from "./components/ModernHeader";
import HeroSection from "./components/HeroSection";
import WhyLamaziNew from "./components/WhyLamaziNew";
import ProductsSection from "./components/ProductsSection";
import PackagingSection from "./components/PackagingSection";
import LogisticsSection from "./components/LogisticsSection";
import CertificationsSection from "./components/CertificationsSection";
import TestimonialsSection from "./components/TestimonialsSection";
import InstagramSection from "./components/InstagramSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import { content } from "./data/mockData";

function App() {
  // Get language from localStorage or default to 'en'
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('preferredLanguage') || 'en';
  });

  // Smooth scroll behavior
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
  }, []);

  const currentContent = content[language];

  return (
    <div className="App">
      <ModernHeader 
        content={currentContent} 
        language={language} 
        setLanguage={setLanguage} 
      />
      <HeroSection content={currentContent} />
      <WhyLamaziNew content={currentContent} />
      <ProductsSection content={currentContent} />
      <PackagingSection content={currentContent} />
      <LogisticsSection content={currentContent} />
      <CertificationsSection content={currentContent} />
      <TestimonialsSection content={currentContent} />
      <InstagramSection content={currentContent} />
      <ContactSection content={currentContent} language={language} />
      <Footer content={currentContent} />
      <Toaster />
    </div>
  );
}

export default App;
